define('common/views/reminders_view_mdreminders',['require','exports','module','base/view','backbone','i18n','react','react-dom','mdremindersjs','ThemesHelper'],function (require, exports, module) {
  'use strict';

  var View = require('base/view'),
    Backbone = require('backbone'),
    i18n = require('i18n'),
    React = require('react'),
    ReactDOM = require('react-dom'),
    MDReminders = require('mdremindersjs'),
    ThemesHelper = require('ThemesHelper');

  var userLang;

  var Reminders = Backbone.View.extend({
    getCurrentLang: function () {
      return i18n.lng().substr(0, 2);
    },

    render: function () {
      var remindersOptions = {
        theme: ThemesHelper.getCurrentTheme(),
        lang: userLang || this.getCurrentLang(),
        title: $.i18n.translate('reminders.userNotValidated.title'),
        message: $.i18n.translate('reminders.userNotValidated.message'),
        closeable: true,
        type: 'warning',
        icon: 'CreditCardIcon',
      };

      ReactDOM.render(
        React.createElement(MDReminders, remindersOptions),
        this.el
      );
      return this;
    },

    refresh: function () {
      this.render();
    },
  });

  module.exports = Reminders;
});

